<form
  (keydown.enter)="$event.preventDefault()"
  data-cy="availability-selection-dialog">
  <div mat-dialog-title>
    <h1 mat-dialog-title>{{ (data$ | async)?.personName }}</h1>
  </div>
  <div mat-dialog-content>
    <h2>
      {{
        ("availabilitySelectionWarning" | i18n) ||
          "Achtung: Informationen zur Verfügbarkeit"
      }}
    </h2>
    <p>
      {{
        ("availabilitySelectionWarningText" | i18n) ||
          "Es gibt zusätzliche Informationen zu dieser Verfügbarkeit. Bitte überprüfen Sie diese."
      }}
    </p>
    <div
      class="row"
      *ngIf="(data$ | async)?.restWarning">
      <div class="col-md-12">
        <div>
          {{ ("restWarning" | i18n) || "Ruhezeit nicht gewährleistet" }}:
        </div>
        <span class="text-small">{{ (data$ | async)?.restWarning }}</span>
      </div>
    </div>
    <div
      class="row"
      *ngIf="(data$ | async)?.note">
      <div class="col-md-12">
        <div>{{ ("availabilityNote" | i18n) || "Verfügbarkeitsnotiz" }}:</div>
        <span class="text-small">{{ (data$ | async)?.note }}</span>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button
      mat-button
      class="cancel-button"
      (click)="onNoClick()">
      {{ ("cancel" | i18n) || "cancel" | uppercase }}
    </button>
    <button
      mat-button
      class="save-button"
      [mat-dialog-close]="{ confirmed: true }"
      data-cy="availability-selection-submit-button">
      <span class="mat-fab__label">{{
        ("continue" | i18n) || "weiter" | uppercase
      }}</span>
    </button>
  </div>
</form>
